export default "__VITE_ASSET__BEdwB8jF__"